import React from 'react';

export default ({ handleSortClick, order, sortedBy }) => {
  function createClasses(key) {
    if (sortedBy === key) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list-scene__table-header'>
      <div className='table-body-col expand-button' />
      <div className='list-scene__table-header-element _width_pc_8' />
      <div
        className={`list-scene__table-header-element ${createClasses('id')} _width_pc_10`}
        onClick={handleSortClick('id')}
      >
        <div>ID</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('name')} _width_pc_36`}
        onClick={handleSortClick('name')}
      >
        <div>Boat Name</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('boatType')} _width_pc_12`}
        onClick={handleSortClick('boatType')}
      >
        <div>Boat Type</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('engineType')} _width_pc_12`}
        onClick={handleSortClick('engineType')}
      >
        <div>Engine Type</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div
        className={`list-scene__table-header-element ${createClasses('status')} _width_pc_10`}
        onClick={handleSortClick('status')}
      >
        <div>Status</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>
      <div className='list-scene__table-header-element _width_pc_12' />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/List/TableHeader.jsx